import { cn } from '../../utils/cn'

// stats: array de { value, label, highlight }
export default function ValuePropStats({
  title = "Explicando a proposta de valor em '30s'",
  intro,
  note,
  noteTitle,
  statsLabel,
  closing,
  stats = [],
  accentBorderClass = 'border-[#FF4D1C]',
}) {
  return (
    <div className="w-full px-20 pb-16">
      {title && (
        <h2 className="mb-6 font-inter-extrabold text-2xl text-[#454545]">
          {title}
        </h2>
      )}

      {intro && (
        <div className={cn('mb-8 border p-7', accentBorderClass)}>
          <p className="font-inter-regular text-lg leading-relaxed text-[#454545] whitespace-pre-line">
            {intro}
          </p>
        </div>
      )}

      {note && (
        <div className="mb-8 rounded-[10px] border border-[#E5E7EB] bg-[#FAFAFA] p-6">
          {noteTitle && (
            <p className="mb-2 font-inter-semibold text-base text-[#454545]">
              {noteTitle}
            </p>
          )}
          <p className="font-inter-regular text-base leading-relaxed text-[#364153] whitespace-pre-line">
            {note}
          </p>
        </div>
      )}

      {statsLabel && (
        <p className="mb-4 font-inter-semibold text-base text-[#454545]">
          {statsLabel}
        </p>
      )}

      {stats.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={cn(
                'flex flex-col gap-1 rounded-[10px] bg-[#F9FAFB] px-4 pt-4',
                stat.highlight &&
                  'border-2 border-[#99020E] bg-[#FF4D1C1A] pb-[2px]',
              )}
            >
              <span
                className={cn(
                  'font-inter-extrabold text-3xl',
                  stat.highlight ? 'text-[#99020E]' : 'text-[#454545]',
                )}
              >
                {stat.value}
              </span>
              <span
                className={cn(
                  'font-inter-regular text-xs',
                  stat.highlight ? 'text-[#99020E]' : 'text-[#4A5565]',
                )}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      )}

      {closing && (
        <p className="mt-6 font-inter-regular text-base leading-relaxed text-[#333333]">
          {closing}
        </p>
      )}
    </div>
  )
}
